import { useState, useEffect } from "react";
import { DateTime } from "luxon";
import DownloadReportCSV from "./DownloadReportCSV";
import { formatTimestamp } from "../Utils/helper";

export default function ScreenShow({
  campaign,
  Toast,
  getAxiosInstance,
  screenCount,
  showCampaign,
}) {
  const [IsShowing, setIsShowing] = useState(false);
  const [screens, setScreens] = useState([]);
  const [campaigns, setCampaigns] = useState(null);

  const campaignsHeaders = [
    "Screen ID",
    "Screen",
    "Duration",
    "Date/Time",
    "Status",
    "Floor",
    "Building",
    "City",
    "State",
    "Country"
  ];

  function handleClose() {
    setIsShowing(false);
  }

  useEffect(() => {
    if (campaign && IsShowing) {
      setCampaigns(campaign);
      let jsonData = {
        id: campaign?._id,
      };
      // converting (json --> form-urlencoded)
      const data = Object.keys(jsonData)
        .map((key) => `${key}=${encodeURIComponent(jsonData[key])}`)
        .join("&");

      getAxiosInstance()
        .post("/admin/single-campaigns", data, {
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        })
        .then((res) => {
          // Validating form
          if (res.data.status === "success") {
            // console.log(res.data.result);
            setCampaigns(res.data.result);
          } else if (res.data.status === "error")
            Toast.fire({ icon: "error", title: res.data.message });
          else Toast.fire({ icon: "error", title: "Cannot process request" });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [campaign, IsShowing]);

  useEffect(() => {
    if (IsShowing && campaign?._id) getScreens();
  }, [IsShowing, campaign]);

  const getScreens = () => {
    let jsonData = {
      campaign: campaign?._id,
    };
    // converting (json --> form-urlencoded)
    const data = Object.keys(jsonData)
      .map((key) => `${key}=${encodeURIComponent(jsonData[key])}`)
      .join("&");

    getAxiosInstance()
      .post("/admin/screens-message-log", data, {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      })
      .then((res) => {
        // Validating form
        if (res.data.status === "success") {
          // console.log(res.data.result);
          setScreens(res.data.result);
        } else if (res.data.status === "error")
          Toast.fire({ icon: "error", title: res.data.message });
        else Toast.fire({ icon: "error", title: "Cannot process request" });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  function millisToMinutesAndSeconds(millis) {
    var minutes = Math.floor(millis / 60000);
    var seconds = ((millis % 60000) / 1000).toFixed(0);
    return minutes + ":" + (seconds < 10 ? "0" : "") + seconds;
    //return minutes + " Min";
  }

  return (
    <>
      {!showCampaign && (
        <button
          type="button"
          class="btn btn-secondary btn-sm ml-1"
          onClick={() => setIsShowing(true)}
        >
          {screenCount} Screen(s)
        </button>
      )}
      {showCampaign && (
        <span
          onClick={() => setIsShowing(true)}
          style={{ cursor: "pointer", color: "#0096FF" }}
        >
          {campaign?.name}{" "}
          {campaign && campaign.scheduled && (
            <i class="fas fa-clock text-dark"></i>
          )}
        </span>
      )}
      {IsShowing && (
        <div
          className={`modal fade show`}
          id="modal-default"
          style={{ display: "block", paddingRight: 17 }}
          aria-modal="true"
          role="dialog"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title"></h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={(e) => handleClose()}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div
                className="modal-body"
                style={{ maxHeight: "70vh", overflowY: "auto" }}
              >
                <div className="row">
                  <div className="col-md-12">
                    <h5 className="modal-title">Campaign Details</h5>
                    <table className="table table-head-fixed text-nowrap">
                      <thead>
                        <tr>
                          <th>Campaign Name</th>
                          <th>Additional Note</th>
                          <th>Time and Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        <td>{campaigns?.name}</td>
                        <td>{campaigns?.notes}</td>
                        {campaigns?.scheduled ? (
                          <td>
                            {DateTime.fromMillis(
                              new Date(campaign.start_time).getTime()
                            ).toFormat("dd LLL yyyy h:mm a")}{" "}
                            -{" "}
                            {DateTime.fromMillis(
                              new Date(campaigns.end_time).getTime()
                            ).toFormat("dd LLL yyyy h:mm a")}
                          </td>
                        ) : campaigns ? (
                          <td>
                            {DateTime.fromMillis(
                              new Date(campaigns.start_time).getTime()
                            ).toFormat("dd LLL yyyy h:mm a")}
                          </td>
                        ) : (
                          <td></td>
                        )}
                      </tbody>
                    </table>
                  </div>

                  <div className="col-md-12">
                    <h5 className="modal-title">User Details</h5>
                    <table className="table table-head-fixed text-nowrap">
                      <thead>
                        <tr>
                          <th>User Name</th>
                          <th>User ID</th>
                          <th>User Location</th>
                        </tr>
                      </thead>
                      <tbody>
                        <td>
                          {campaigns?.user?.first_name}{" "}
                          {campaigns?.user?.last_name}
                        </td>
                        <td>{campaigns?.user?.employee_code}</td>
                        <td>{campaigns?.user?.address}</td>
                      </tbody>
                    </table>
                  </div>

                  <div className="col-md-12">
                    <div className="modal-header">
                      <h5 className="modal-title">Screens List</h5>
                      <DownloadReportCSV headers={campaignsHeaders} data={screens} />
                    </div>
                    <table className="table table-head-fixed text-nowrap">
                      {/* headers */}
                      <thead>
                        <tr>
                          {campaignsHeaders.map((header, i) => <th key={i}>{header}</th>)}
                        </tr>
                      </thead>
                      {/* body */}
                      <tbody>
                        {screens?.length === 0 && (
                          <tr style={{ textAlign: "center" }}>
                            <td colSpan={10}>No Screen Found</td>
                          </tr>
                        )}
                        {screens?.map((screen, i) => (
                          <tr key={i}>
                            <td>{screen.screen?.uid || screen.screen?.id}</td>
                            <td>{screen.screen?.name}</td>
                            <td>
                              {millisToMinutesAndSeconds(screen.duration)}
                            </td>
                            <td>
                              {formatTimestamp(screen.start_time)}
                            </td>
                            <td>
                              {" "}
                              {screen.active === 0 ? (
                                <span className="text-danger">Failure</span>
                              ) : (
                                <span className="text-success">Success</span>
                              )}
                            </td>
                            <td>{screen.floor?.name}</td>
                            <td>{screen.building?.name}</td>
                            <td>{screen.city?.name}</td>
                            <td>{screen.state?.name}</td>
                            <td>{screen.country?.name}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
